module.exports = __webpack_public_path__ + "img/icon_mask_money.a311ab2d.png";